import { render, staticRenderFns } from "./MppMoneyPay.vue?vue&type=template&id=3d57fe9c&scoped=true&"
import script from "./MppMoneyPay.vue?vue&type=script&lang=js&"
export * from "./MppMoneyPay.vue?vue&type=script&lang=js&"
import style0 from "./MppMoneyPay.vue?vue&type=style&index=0&id=3d57fe9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57fe9c",
  null
  
)

export default component.exports